import classnames from 'classnames'

import { NUMBER_SIZE } from '../../../../../constants/size'
import { getQaSelector } from '../../../../../utils/common'
import { Input, InputContainer } from '../../../../Input'
import { QA_NAME_COLOR_PICKER_POPOVER_PREVIEW_INPUT } from '../ColorPickerPopoverPreview.constants'

import * as styles from '../ColorPickerPopoverPreview.module.css'

function ColorPickerPopoverPreviewHexInput({
  hexInputFocused,
  inputRef,
  text,
  onBlur,
  onChange,
  onFocus,
}) {
  const qaProps = getQaSelector({
    value: QA_NAME_COLOR_PICKER_POPOVER_PREVIEW_INPUT,
  })

  return (
    <div className={classnames(styles.inputOuter, styles.inputOuterHex)}>
      <InputContainer
        className={classnames(styles.inputContainer, styles.inputContainerHex)}
        focused={hexInputFocused}
        height={NUMBER_SIZE.size24}
      >
        <Input
          {...qaProps}
          className={classnames(styles.valueInput, styles.valueInputHex)}
          ref={inputRef}
          value={text}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
        />
      </InputContainer>
    </div>
  )
}

export default ColorPickerPopoverPreviewHexInput
